"use client";

import { c as _c } from "react/compiler-runtime";
import { useCommon } from "@v3/_/hooks/use-translation";
import { cn } from "@v3/_/lib/utils";
import { isField, isRetiredField } from "@/fields";
import { FieldIcon, type FieldIconKey } from "@/icons/field-icons";
export function useFieldLabel() {
  const $ = _c(2);
  const c = useCommon();
  let t0;
  if ($[0] !== c) {
    t0 = field => {
      if (isField(field)) {
        return c.plain(`fields.label.${field}`);
      }
      if (isRetiredField(field)) {
        return c.plain(`fields.retired.${field}`);
      }
      return field;
    };
    $[0] = c;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function FieldChip(t0) {
  const $ = _c(11);
  const {
    field,
    className
  } = t0;
  const label = useFieldLabel();
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex items-center gap-1 align-[-0.125em] font-semibold whitespace-nowrap", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = field as FieldIconKey;
  let t3;
  if ($[2] !== t2) {
    t3 = <FieldIcon field={t2} size="xs" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== field || $[5] !== label) {
    t4 = label(field);
    $[4] = field;
    $[5] = label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t5 = <span className={t1}>{t3}{t4}</span>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}